import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from '../header/header.component';

@Component({
  selector: 'app-splash',
  templateUrl: './splash.component.html',
  imports: [RouterOutlet, HeaderComponent, FooterComponent],
  standalone: true,
})
export class SplashComponent {}
